import { Skeleton } from '@mui/material'
import React from 'react'

export const Loader = () => {
    return (
        <>
            {
                [1, 2, 3, 4, 5].map((item) => (
                    <div className='py-2 relative flex gap-1 items-center cursor-pointer text-black shadow-sm border bg-white  rounded text-xs text-center'>

                        <Skeleton className='mx-1' variant='rounded' width={40} height={40} />
                        <div>
                            <Skeleton width={80} />
                            <Skeleton width={80} />
                        </div>

                    </div>
                ))
            }

        </>
    )
}
